export default __webpack_public_path__ + "static/23-060ce960f9d399d05ec21b3ee6bdb2db.jpg";